// removed by extract-text-webpack-plugin
module.exports = {"new_right_wb":"_3CIsDnj5YCETqVXP4OoGpH","icon_tou":"_1R5gOehAdQr-rd0wUmmTA0","icon_name":"_24aQYMiP0C5gzPKxWvflSS","span1":"_1zqlKn-g-fQ8xPQ2oVnwSH","span2":"_3a2fCKS6kVX9xBJ0snOMs_","nei_box":"_3rVL0PnuVzdeD9FYJYWpKT","img_banner":"_1vZYKUBz9S2K4epTQai5nd","nei_right":"_2Ej2YQVSbq-uWQWyJLBmcn","h1":"HE2IezwOddmVOF__ODs3F","h2":"_-RiTGlLZznEIkTBjAJRtr","date":"_2ZbeFErlU2W2X2Lkn3ZsP9","fans":"_2PjTQFJqQ1kdWYMSd7OBeu"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewMediumWeiBoComponent/NewMediumWeiBoComponent.scss
 ** module id = 1000
 ** module chunks = 0
 **/